// extracted by mini-css-extract-plugin
export default {"formBlock":"FormBlock_formBlock__jIdRt","title":"FormBlock_title__nw4Xl","content":"FormBlock_content__8Mai-"};